const STRIP_STYLE_PROPS = [
  'font-size',
  'line-height',
  'font-family',
  'font',
  'background',
  'background-color',
]

/** Remove size/font styling so page content follows site CSS only. Keeps color. */
export function sanitizeEditorHtml(html) {
  if (!html || typeof html !== 'string') return html

  if (typeof DOMParser === 'undefined') {
    return html.replace(/\sfont-size\s*:\s*[^;"]+;?/gi, '')
  }

  const doc = new DOMParser().parseFromString(html, 'text/html')

  doc.querySelectorAll('font[size]').forEach((node) => {
    const span = doc.createElement('span')
    span.innerHTML = node.innerHTML
    if (node.getAttribute('color')) {
      span.style.color = node.getAttribute('color')
    }
    node.replaceWith(span)
  })

  doc.querySelectorAll('*').forEach((el) => {
    if (el.removeAttribute) {
      el.removeAttribute('size')
    }

    if (el.style) {
      STRIP_STYLE_PROPS.forEach((prop) => el.style.removeProperty(prop))
    }

    const style = el.getAttribute('style')
    if (!style) return

    const cleaned = style
      .split(';')
      .map((part) => part.trim())
      .filter(Boolean)
      .filter((part) => {
        const key = part.split(':')[0]?.trim().toLowerCase()
        return key && !STRIP_STYLE_PROPS.includes(key)
      })
      .join('; ')

    if (cleaned) {
      el.setAttribute('style', cleaned)
    } else {
      el.removeAttribute('style')
    }
  })

  return doc.body.innerHTML
}
